import { Award, Download } from "lucide-react";
import { API } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Certificate() {
  const { user } = useAuth();

  const download = () => {
    window.open(`${API}/certificate?v=${Date.now()}`, "_blank", "noopener");
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="certificate-page">
      <div className="card-room text-center !p-10">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-[#0C1530] border border-[#F5A623]/50 flex items-center justify-center text-[#F5A623] mb-5">
          <Award size={32} />
        </div>
        <h1 className="text-2xl sm:text-3xl font-semibold text-white mb-3">Certificado de Participação</h1>
        {user?.certificate_released ? (
          <>
            <p className="text-base text-slate-300 mb-6">
              Parabéns, {user.name || user.email}! Seu certificado está disponível para download.
              Ele também foi enviado para o seu e-mail.
            </p>
            <button onClick={download} className="btn-primary inline-flex items-center gap-2" data-testid="download-certificate-btn">
              <Download size={16} /> Baixar certificado (PDF)
            </button>
          </>
        ) : (
          <p className="text-base text-slate-400" data-testid="certificate-pending-msg">
            Seu certificado ainda não foi liberado. Assim que a organização liberar,
            você receberá um e-mail e poderá baixá-lo aqui.
          </p>
        )}
      </div>
    </div>
  );
}
